import * as React from "react"
import {WithModalStore} from "../App"
import {persistedState} from "../localStorage"
import {none, some} from "fp-ts/lib/Option"
import {AddBookingWizard} from "./AddBookingWizard"
import {UrlLocaleIdProp} from "../urlLocale"

interface Props extends WithModalStore {}

interface AllProps extends Props, UrlLocaleIdProp {}

export function AddBooking(props: AllProps) {
  const {modalStore} = props
  return (
    <AddBookingWizard
      isRepeatOrReturn={false}
      modalStore={modalStore}
      urlLocaleId={props.urlLocaleId}
      initialState={persistedState.value.toNullable()}
      onState={(x) => {
        persistedState.value = some(x)
      }}
      onSave={() => {
        persistedState.value = none
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/AddBooking.tsx